import { MarkdownText } from "@/components/common/MarkdownText";
import { useState } from "react";
import { useIntl } from "react-intl";
import { NoBackend } from "@/components/common/NoBackend";

interface Image { mimeType?: string | null; content?: string | null }
interface Content { name?: string | null; description?: string | null; mainImage?: Image | null; images?: readonly (Image | null)[] | null }
const imgSrc = (file: Image) => `data:${file.mimeType || "image/jpeg"};base64,${file.content}`;

export function ShareItemContent({ item }: { item: Content }) {
  const intl = useIntl();
  const gallery = [item.mainImage, ...(item.images ?? [])].filter((image): image is Image => Boolean(image?.content));
  const [activeIdx, setActiveIdx] = useState(0);
  const hero = gallery[activeIdx] ?? gallery[0];
  return <>
                {hero ? (
                  <div className="mt-5">
                    <div className="overflow-hidden rounded-md bg-ink/[0.06] ring-1 ring-ink/5">
                      <img
                        id="share-item-hero"
                        src={imgSrc(hero) ?? ""}
                        alt={item.name || ""}
                        className="aspect-[16/9] w-full object-cover"
                      />
                    </div>
                    {gallery.length > 1 ? (
                      <div className="mt-3 flex gap-2 overflow-x-auto pb-1">
                        {gallery.map((f, i) => (
                          <button
                            key={i}
                            type="button"
                            onClick={() => setActiveIdx(i)}
                            title={intl.formatMessage(
                              { id: "share.itemDetail.imageN", defaultMessage: "Image {n}" },
                              { n: i + 1 },
                            )}
                            className={`shrink-0 overflow-hidden rounded-md ring-1 transition ${
                              i === activeIdx ? "smycles-selected ring-2 ring-accent-decoration" : "ring-ink/10 hover:ring-accent-decoration/40"
                            }`}
                          >
                            <img src={imgSrc(f) ?? ""} alt="" className="h-16 w-24 object-cover" />
                          </button>
                        ))}
                      </div>
                    ) : null}
                  </div>
                ) : null}

                <div className="mt-6 border-t border-ink/5 pt-5">
                  {item.description ? (
                    <div className="whitespace-pre-wrap text-smycles-body leading-relaxed text-ink">
                      <MarkdownText content={item.description} />
                    </div>
                  ) : (
                    <NoBackend
                      label={intl.formatMessage({ id: "share.itemDetail.noDescription", defaultMessage: "No description" })}
                      hint={intl.formatMessage({ id: "share.itemDetail.noDescriptionHint", defaultMessage: "no content provided" })}
                    />
                  )}
                </div>

  </>;
}
